<!--
 * @Author: FRX
 * @Date: 2022-08-22 11:14:43
 * @LastEditors: FRX
 * @LastEditTime: 2022-09-08 14:21:13
 * @Description: 
-->
<template>
    <div>
        <van-popup v-model:show="show" round >
            <div class="report-popup">
                <p v-if="content.title" class="title">{{ content.title }}</p>
                <img v-show="content.icon" :src="content.icon">
                <div class="content" :class="{'tip': content.title }" v-html="content.msg"></div>
                <button class="confirm-upload" @click="toJump">{{ content.confirmText ? content.confirmText : "确定" }}</button>
            </div>
        </van-popup>
        <van-icon name="close" v-show="show && content.title" @click="show = false" class="close-icon" />
    </div>
</template>

<script>
export default {
    data() {
        return {
            show: false,
        }
    },
    props: {
        content: {
            type: Object,
            default: function() {
                return {
                    state: 1,
                    msg: '',
                    icon: '',
                    title: '',
                    confirmText: '确定'
                }
            },
        }
    },
    methods: {
        toJump() {
            this.show = false
            this.$emit('confrim')
        }
    },
}
</script>
<style lang="scss" scoped>
@import "@/assets/css/function.scss";
    .report-popup {
        width: getsize(600px);
        height: getsize(600px);
        background: #FFFFFF;
        position: relative;
        text-align: center;
        padding-bottom: getsize(20px);
        p {
            color: #333333;
            font-weight: bold;
            line-height: getsize(50px);
            font-family: PingFangSC-Medium, PingFang SC;
        }
        .title {
            padding: getsize(50px) 0;
            font-size: getsize(44px);
            font-weight: bold;
            color: #333333;
        }
        img {
            margin-top: getsize(48px);
            width: getsize(164px);
            height: getsize(164px);
        }
        .content {
            width: 100%;
            padding: 0 getsize(30px);
            box-sizing: border-box;
            margin-top: getsize(8px);
            font-size: getsize(34px);
            height: getsize(300px);
            color: #333333;
            font-weight: bold;
            line-height: getsize(50px);
            font-family: PingFangSC-Medium, PingFang SC;
            &.tip {
                font-weight: normal;
            }
        }
        button {
            position: absolute;
            width: getsize(418px);
            height: getsize(98px);
            left: 50%;
            bottom: getsize(70px);
            transform: translateX(-50%);
            border-radius: getsize(49px);
            font-size: getsize(36px);
            font-weight: bold;
            background: linear-gradient(270deg, #F55B44 0%, #FA7519 100%);
            box-shadow: 0px getsize(6px) getsize(36px) getsize(-16px) #F55B43;
            color: #ffffff;
        }
    }
    ::v-deep .van-popup--center.van-popup--round {
        border-radius: getsize(30px);
    }
    .close-icon {
        font-size: getsize(70px);
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%,getsize(400px));
        z-index: 10000;
        color: #ffffff;
    }

</style>